<ng-container *ngIf="isReturnFailed">
    <section class="col-xs-12 col-md-12 mt-5" id="retrunserror" *ngIf="sorryMsg | async as item">
        <div class="thankorder_box">
            <div class="returnsorry_text" [innerHtml]="item.content"></div>
        </div>
    </section>
</ng-container>